<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vs-tabs
          :position="isSmallerScreen ? 'top' : 'left'"
          class="tabs-shadow-none"
          id="profile-tabs"
          :value="tabIndex"
          :key="isSmallerScreen"
        >
          <vs-tab
            icon-pack="feather"
            icon="icon-user"
            :label="!isSmallerScreen ? 'Persoonlijke gegevens' : ''"
          >
            <personal-details-tab></personal-details-tab>
          </vs-tab>
          <vs-tab
            icon-pack="feather"
            icon="icon-dollar-sign"
            :label="!isSmallerScreen ? 'Betalingsgegevens' : ''"
          >
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <payment-info-tab></payment-info-tab>
            </div>
          </vs-tab>
          <vs-tab
            icon-pack="feather"
            icon="icon-edit"
            :label="!isSmallerScreen ? 'Wijzigingen' : ''"
            v-if="false"
          >
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <mutation-requests-table></mutation-requests-table>
            </div>
          </vs-tab>

          <vs-tab
            icon-pack="feather"
            icon="icon-file"
            :label="!isSmallerScreen ? 'Documenten' : ''"
          >
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <documents-tab></documents-tab>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import MutationRequestsTable from "@/layouts/components/MutationRequestsTable.vue";
import personalDetailsTab from "@/components/profile/personalDetailsTab.vue";
import paymentInfoTab from "@/components/profile/paymentInfoTab.vue";
import DocumentsTab from "@/components/profile/DocumentsTab.vue";
export default {
  props: {
    tab: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tabKeys: ["personal", "payment", "documents"]
    };
  },
  components: {
    MutationRequestsTable,
    personalDetailsTab,
    paymentInfoTab,
    DocumentsTab
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    tabIndex() {
      let idx = this.tabKeys.indexOf(this.tab);
      return idx > -1 ? idx : 0;
    }
  }
};
</script>
